const isDev = process.env.NODE_ENV !== 'production' // 本地开发环境
const isProd = location.href.includes('qw.fadada.com') // 生产现网环境 //ioo fix
const envCfg = window.g || {}
const baseURL = isDev ? '' : envCfg.baseURL

// 全局公共配置，组件内部通过 this.$config.key 来访问
export default {
  isDev,

  isProd,

  // 环境配置
  ...envCfg,

  // 网关
  baseURL,
  basePathNew: baseURL + '/ecoSystem',

  // 服务根路径
  basePath: baseURL + '/ecoSystem/api/v1',

  // 空字段占位
  empty: '—'
}

// delete window.g
